import Vue from "vue";
import App from "./App.vue";

new Vue({ render: (createElement) => createElement(App) }).$mount("#app");
